<template>
  <q-page class="q-pa-sm">
    <breadcrumbs />
    <div>
      <div class="row q-gutter-sm">
        <q-input
          v-model="supportArticlesSearch"
          class="q-mt-sm col"
          dense
          label="Search support articles..."
          input-class="allow-global-search"
          autofocus
        />
        <q-btn
          v-if="currentUser && currentUser.superUser"
          class="col-auto"
          round
          icon="more_vert"
        >
          <q-menu
            bordered
            side="right"
            overlay
          >
            <q-list style="width: 200px;">
              <q-item
                v-close-popup
                clickable
                @click="createCategory()"
              >
                <q-item-section avatar>
                  <q-icon name="add" />
                </q-item-section>
                <q-item-section>
                  New Category
                </q-item-section>
              </q-item>
            </q-list>
            <q-item
              v-close-popup
              clickable
            >
              <q-item-section>
                <q-toggle
                  v-model="editing"
                  label="Edit Support Articles"
                />
              </q-item-section>
            </q-item>
          </q-menu>
        </q-btn>
      </div>
      <transition-group
        name="list-complete"
      >
        <support-category-menu-item
          v-for="category in filteredList"

          :key="category.id"

          class="list-complete-item q-my-lg q-pb-md"
          style="display: block;"

          :category="category"

          :editing="editing"

          :dragging-category-id="draggingCategoryId"
          :dragging-support-article-id="draggingSupportArticleId"
          :selected-support-article-ids="selectedSupportArticleIds"

          @drag-start-category="id => draggingCategoryId = id"
          @drag-end-category="(id, dropAfter) => dragTo(id, null, dropAfter)"

          @drag-start-support-article="id => draggingSupportArticleId = id"
          @drag-end-support-article="(id, dropAfter) => dragTo(null, id, dropAfter)"

          @select-support-article="article => selectSupportArticle(article)"

          @delete-support-articles="ids => deleteSupportArticles(ids)"

          @create-category="displayOrder => createCategory(displayOrder)"
          @edit-category="category => editCategory(category)"
          @change="supportArticles.fetch(true); supportCategories.fetch(true)"
        />
      </transition-group>
      <q-inner-loading :showing="saving || supportArticles.loading || supportCategories.loading" />
    </div>
    <support-category-form
      ref="supportCategoryForm"
      @change="supportArticles.fetch(true); supportCategories.fetch(true)"
    />
    <support-article-dialog
      v-model="showSupportArticleDialog"
      :support-article="selectedSupportArticle"
      @close="unselectSupportArticle()"
    />
  </q-page>
</template>

<script>
import { Notify } from 'quasar'
import { adminRoot } from 'src/config'
import SupportArticle from 'src/models/support/SupportArticle'
import Breadcrumbs from 'src/modules/admin/components/Breadcrumbs'
import SupportCategoryMenuItem from 'src/modules/admin/support/SupportCategoryMenuItem.vue'
import SupportArticleDialog from 'src/modules/admin/support-article/SupportArticleDialog.vue'
import SupportCategoryForm from 'src/modules/admin/support-category/SupportCategoryForm.vue'

export default {
  name: 'SupportArticlesMenu',
  components: {
    Breadcrumbs,
    SupportCategoryMenuItem,
    SupportCategoryForm,
    SupportArticleDialog
  },
  data () {
    return {
      supportArticlesSearch: '',
      savingRoute: null,
      saving: false,
      draggingCategoryId: null,
      draggingSupportArticleId: null,
      selectedSupportArticleIds: [],
      editing: false,
      showSupportArticleDialog: false,
      selectedSupportArticle: null
    }
  },
  computed: {
    filteredList () {
      return this.buildList(this.supportCategoryMenuItems)
    },
    // TODO Only show published articles unless editing
    supportCategoryMenuItems () {
      const supportCategoryMenuItems =
      _(this.supportArticles.data)
        .filter('supportCategory')
        .filter(supportArticle => this.editing || supportArticle.published)
        .groupBy(supportArticle => supportArticle.supportCategory?.name)
        .map((supportArticles, categoryName) => {
          return {
            name: categoryName,
            id: supportArticles[0].supportCategory.id,
            displayOrder: supportArticles[0].supportCategory.displayOrder,
            entries: supportArticles
          }
        })
        .concat(
          // Add empty categories if editing
          !this.editing
            ? []
            : _(this.supportCategories.data)
              .filter(category => !_.includes(_.map(this.supportArticles.data, 'supportCategory.id'), category.id)).value()
        )
        .sortBy(menuItem => _(this.supportCategories.data).map('name').indexOf(menuItem.name))
        .value()

      return supportCategoryMenuItems
    }
  },
  watch: {
    'supportArticle.id' () {
      if (this.supportArticle) {
        this.selectSupportArticle(this.supportArticle)
      }
    }
  },
  context: ['currentUser'],
  models: {
    supportArticles: {
      supportCategory: 'default',
      variables: {
        limit: 200
      }
    },
    supportCategories: 'default',
    supportArticle: {
      supportCategory: 'default',
      variables () {
        return {
          id: this.$route.params.id,
          skip: !this.$route.params.id
        }
      },
      immediate: true
    }
  },
  methods: {
    nameOrTitle (menuItem) {
      // Support item categories have a name, but support item articles have a title.
      return menuItem.name || menuItem.title
    },
    buildList (supportCategoryMenuItems, all = false, subsearch = false, parentItem = null) {
      const buildList = []

      _.each(supportCategoryMenuItems, supportCategoryMenuItem => {
        supportCategoryMenuItem = _.clone(supportCategoryMenuItem)
        if (all || _.includes((this.nameOrTitle(supportCategoryMenuItem)).toLowerCase(), this.supportArticlesSearch.toLowerCase())) {
          if (!subsearch && this.$route.params.category && _.kebabCase((this.nameOrTitle(supportCategoryMenuItem)).toLowerCase()) !== this.$route.params.category) return

          supportCategoryMenuItem.entries = _.map(supportCategoryMenuItem.entries, supportArticle => {
            supportArticle = supportArticle.clone(supportArticle)
            if (!supportArticle.route || supportArticle.route[0] !== '/') {
              supportArticle.route = adminRoot + 'support/' + (supportCategoryMenuItem.route || _.kebabCase((this.nameOrTitle(supportCategoryMenuItem)))) + '/' + supportArticle.id
            }
            return supportArticle
          })

          if (parentItem) {
            supportCategoryMenuItem = _.clone(supportCategoryMenuItem)
            supportCategoryMenuItem.route = adminRoot + 'support/' + (parentItem.route || _.kebabCase(parentItem.name)) + '/' + supportCategoryMenuItem.id
          }

          buildList.push(supportCategoryMenuItem)
        } else {
          if (!subsearch && this.$route.params.category && _.kebabCase((this.nameOrTitle(supportCategoryMenuItem)).toLowerCase()) !== this.$route.params.category) return

          supportCategoryMenuItem.entries = this.buildList(supportCategoryMenuItem.entries, false, true, supportCategoryMenuItem)
          if (supportCategoryMenuItem.entries.length === 0) return

          buildList.push(supportCategoryMenuItem)
        }
      })

      return buildList
    },
    async dragTo (dropCategoryId, dropSupportArticleId, dropAfter = false) {
      // Check for non-moves
      if (this.draggingCategoryId === null && this.draggingSupportArticleId === null) return
      if (this.draggingCategoryId !== null && this.draggingCategoryId === dropCategoryId) return
      if (this.draggingSupportArticleId !== null && this.draggingSupportArticleId === dropSupportArticleId) return

      if (this.draggingCategoryId !== null && this.draggingSupportArticleId !== null) {
        console.log("DRAGGING BOTH CATEGORY AND ARTICLE, THIS SHOULDN'T BE POSSIBLE")
        return
      }

      if (this.draggingSupportArticleId && dropCategoryId) {
        // Drop support article in new category
        const movingSupportArticle = _.find(this.supportArticles.data, { id: this.draggingSupportArticleId })
        const dropCatagory = _.find(this.supportCategories.data, { id: dropCategoryId })

        if (!movingSupportArticle || !dropCatagory) return

        // Move to end of category
        this.saving = true
        movingSupportArticle.displayOrder = 9999
        movingSupportArticle.supportCategory = dropCatagory
        await movingSupportArticle.save()
      } else if (this.draggingSupportArticleId && dropSupportArticleId) {
        // Drop over other support article (support article moving categories)
        const movingSupportArticle = _.find(this.supportArticles.data, { id: this.draggingSupportArticleId })
        const dropSupportArticle = _.find(this.supportArticles.data, { id: dropSupportArticleId })

        if (!movingSupportArticle || !dropSupportArticle) return

        // Move to after drop support article
        this.saving = true
        movingSupportArticle.displayOrder = dropSupportArticle.displayOrder + (dropAfter ? 5 : -5)
        movingSupportArticle.supportCategory = dropSupportArticle.supportCategory
        await movingSupportArticle.save()
      } else if (this.draggingCategoryId && dropCategoryId) {
        // Drop category over category
        const movingCategory = _.find(this.supportCategories.data, { id: this.draggingCategoryId })
        const dropCategory = _.find(this.supportCategories.data, { id: dropCategoryId })

        if (!movingCategory || !dropCategory) return

        // Move to after drop support article
        this.saving = true
        movingCategory.displayOrder = dropCategory.displayOrder + (dropAfter ? 5 : -5)
        movingCategory.supportCategory = dropCategory.category
        await movingCategory.save()
      } else if (this.draggingCategoryId && dropSupportArticleId) {
        // Blocked
        console.log('DROP CATEGORY ON SUPPORT ARTICLE: DO NOTHING')
      }

      this.supportCategories.fetch(true)
      this.supportArticles.fetch(true)
      this.draggingSupportArticleId = null
      this.draggingCategoryId = null

      this.saving = false
    },
    editCategory (category) {
      this.$refs.supportCategoryForm.show(category)
    },
    createCategory (displayOrder = 999999) {
      this.editing = true
      this.$refs.supportCategoryForm.show(null, { displayOrder })
    },

    create (supportArticle) {
      this.$refs.supportArticleForm.show(null, { supportCategory: supportArticle.supportCategory, displayOrder: supportArticle.displayOrder - 5, user: this.currentUser })
    },
    selectSupportArticle (supportArticle) {
      this.selectedSupportArticle = supportArticle
      this.showSupportArticleDialog = true

      // Silently set the url state so this can be shared
      history.pushState({}, null, '/#/support/' + supportArticle.id)
    },
    unselectSupportArticle () {
      this.selectedSupportArticle = null
      this.$router.push('/support')
    },
    unselectSupportArticles () {
      this.selectedSupportArticleIds = []
    },
    async deleteSupportArticles (ids) {
      this.saving = true

      for (const id of ids) {
        const model = new SupportArticle({ id })
        const { errors } = await model.delete()
        if (errors && errors.length > 0) {
          Notify.create({
            message: 'Error deleting',
            type: 'negative',
            position: 'top'
          })
          console.log(errors)
        }
      }
      this.saving = false

      this.supportArticles.fetch(true)
      this.selectedSupportArticleIds = []
    }
  },
  trackPage: true
}
</script>

<style lang="scss" scoped>
.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
